module.exports = __webpack_public_path__ + "img/achievements_select.33f1118c.svg";